// Adar Jewelry — global.js
document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav
  var burger = document.querySelector('.header__burger');
  if (burger) burger.addEventListener('click', function () {
    document.querySelector('.header__nav').classList.toggle('is-open');
  });

  // Product gallery
  document.querySelectorAll('.product__thumbs img').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.querySelector('.product__main-img img');
      if (main) main.src = t.dataset.full;
      document.querySelectorAll('.product__thumbs img').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  // Variant selection
  var form = document.querySelector('.product__form');
  if (form && window.__productVariants) {
    var variants = window.__productVariants;
    function currentOptions() {
      var opts = [];
      form.querySelectorAll('.opt-group').forEach(function (g) {
        var checked = g.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function refresh() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      form.querySelectorAll('.swatch,.pill').forEach(function (el) {
        el.classList.toggle('selected', el.querySelector('input').checked);
      });
      if (match) {
        form.querySelector('[name=id]').value = match.id;
        var priceEl = document.querySelector('.product__price');
        if (priceEl) {
          var html = '';
          if (match.compare_at_price > match.price) {
            html += '<s>' + Shopify.formatMoney(match.compare_at_price) + '</s><span class="sale">' + Shopify.formatMoney(match.price) + '</span>';
          } else {
            html += Shopify.formatMoney(match.price);
          }
          priceEl.innerHTML = html;
        }
        var btn = form.querySelector('button[type=submit]');
        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available ? btn.dataset.add : btn.dataset.soldout;
        }
      }
    }
    form.querySelectorAll('.opt-group input').forEach(function (i) {
      i.addEventListener('change', refresh);
    });
    refresh();
  }

  // Offer box selection
  document.querySelectorAll('.offer input').forEach(function (i) {
    i.addEventListener('change', function () {
      document.querySelectorAll('.offer').forEach(function (o) { o.classList.remove('selected'); });
      i.closest('.offer').classList.add('selected');
    });
  });
});

// Minimal money formatter (uses shop money format injected by section)
window.Shopify = window.Shopify || {};
Shopify.formatMoney = function (cents) {
  var val = (cents / 100).toFixed(2);
  var fmt = window.__moneyFormat || '${{amount}}';
  return fmt.replace(/\{\{\s*amount\s*\}\}/, val);
};
